/**
 * Where @monaco-editor/react loads Monaco from: the designer's own origin.
 * Its default is cdn.jsdelivr.net, which the designer's CSP (script-src
 * 'self') refuses, so the classic editor's Groovy and XSLT fields never left
 * "Loading…". scripts/copy-monaco.mjs puts the files at /monaco/vs at build
 * time. Nothing is fetched until such a field is first shown.
 */
import { loader } from '@monaco-editor/react';

loader.config({ paths: { vs: '/monaco/vs' } });
